import React from 'react';
import { classNames } from 'primereact/utils';

type ColoredIconProps = {
	src: string;
	size: string;
	color?: string;
	className?: string;
};

export const ColoredIcon = ({ src, size, color, className }: ColoredIconProps) => (
	<div
		className={classNames('flex-shrink-0', className)}
		style={{
			width: size,
			height: size,
			backgroundColor: color || 'currentColor',
			WebkitMaskImage: `url(${src})`,
			WebkitMaskRepeat: 'no-repeat',
			WebkitMaskPosition: 'center',
			WebkitMaskSize: 'contain',
			maskImage: `url(${src})`,
			maskRepeat: 'no-repeat',
			maskPosition: 'center',
			maskSize: 'contain',
		}}
	/>
);
